import React from 'react';
import { useSelector } from 'react-redux';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import ParticipantItem from './ParticipantItem';

const ParticipantList = ({ localUsername, userId, getAvatarColor, raisedHands, screenPresenters, filterValue, onLocalUserClick, setTotalParticipants }) => {
  const guests = useSelector(state => state.participants.guests);
  const hosts = useSelector(state => state.participants.hosts);
  const presenters = useSelector(state => state.participants.presenters);

  // Combine and prepare all participants
  const allParticipants = [
    // Add local user first
    {
      id: userId,
      name: localUsername,
      role: 'You as Guest',
      isLocal: true
    },
    // Add hosts
    ...Object.entries(hosts).map(([id, name]) => ({
      id,
      name,
      role: 'Host',
      hasRaisedHand: raisedHands.has(id.replace(/^(mp-|wt-)/, '')),
      isSharingScreen: screenPresenters.has(id.replace(/^(mp-|wt-)/, ''))
    })),
    // Add presenters
    ...Object.entries(presenters).map(([id, name]) => ({
      id,
      name,
      role: 'Presenter',
      hasRaisedHand: raisedHands.has(id.replace(/^(mp-|wt-)/, '')),
      isSharingScreen: screenPresenters.has(id.replace(/^(mp-|wt-)/, ''))
    })),
    // Add guests (excluding local user)
    ...Object.entries(guests)
      .filter(([id]) => id !== userId)
      .map(([id, name]) => ({
        id,
        name,
        role: 'Guest'
      }))
  ].sort((a, b) => {
    // Sort by role first (Host > Presenter > Guest)
    const roleOrder = { Host: 0, Presenter: 1, Guest: 2, 'You as Guest': -1 };
    if (roleOrder[a.role] !== roleOrder[b.role]) {
      return roleOrder[a.role] - roleOrder[b.role];
    }
    // Then sort by name
    return a.name.localeCompare(b.name);
  });

  // Apply filter
  const filteredParticipants = filterValue
    ? allParticipants.filter(participant => 
        participant.name.toLowerCase().includes(filterValue.toLowerCase())
      )
    : allParticipants;

  const renderRow = ({ index, style }) => {
    const participant = filteredParticipants[index];
    return (
      <div style={style}>
        <ParticipantItem
          key={participant.id}
          id={participant.id}
          name={participant.name}
          role={participant.role}
          getAvatarColor={getAvatarColor}
          hasRaisedHand={participant.hasRaisedHand}
          isSharingScreen={participant.isSharingScreen}
          onLocalUserClick={onLocalUserClick}
        />
      </div>
    );
  };

  // Set the total number of participants
  setTotalParticipants(allParticipants.length);

  return (
    <div className="participant-tab">


      {/* <div className="participant-joined">
        Joined
        <span className="participant-joined-counter">
          {allParticipants.length}
        </span>
      </div> */}

      <div className="participant-list" style={{ height: 'calc(100vh - 200px)' }}>
        <AutoSizer>
          {({ height, width }) => (
            <List
              height={height}
              itemCount={filteredParticipants.length}
              itemSize={50} // Adjust this value based on your ParticipantItem height
              width={width}
            >
              {renderRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </div>
  );
};

export default ParticipantList;